import React from 'react';
import { Segment, Grid } from 'semantic-ui-react';
import '../../assets/css/utils.css';

const ProjectH = () => (
  <div>
    <Segment placeholder>
      <Grid divided='vertically'>        
        <Grid.Row columns={1}>
          <Grid.Column>
            <Segment className="harta-text-justified harta-home-style ph2">
              <p></p>
              <p>Financiado por:</p>
              <p>Estudio de las combinaciones léxicas del español académico basado en corpus para una herramienta de ayuda a la redacción de textos académicos (Ministerio de Economía, Industria y Competitividad FFI2016-78299)</p>
              <p>Estudio de las combinaciones léxicas en un corpus académico de noveles para una herramienta de ayuda a la redacción de textos académicos (Ministerio de Ciencia e Innovación PID2019-109683GB-C21)</p>
              <p>Ayuda para la consolidación y estructuración de unidades de investigación competitivas: Grupos de Referencia Competitiva (Xunta de Galicia ED431C 2020/11)</p>
              <p>Coordinado por Margarita Alonso Ramos (Universidade da Coruña)</p>
              <p></p>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
);

export default ProjectH;